export default [
    { value: 'EVERYDAY_BANKING', en: 'Salary and everyday banking', zh_CN: '工资和日常理财', zh_HK: '薪金和日常理財' },
    { value: 'SAVING_INVESTMENTS', en: 'Savings and Investments', zh_CN: '储蓄和投资', zh_HK: '儲蓄和投資' },
    { value: 'EDUCATIONAL_FUNDS', en: 'Educational funds', zh_CN: '学费', zh_HK: '學費' },
    { value: 'LOANS_MORTGAGE', en: 'Loans, mortgages or other financing', zh_CN: '贷款、按揭或其他融资', zh_HK: '貸款、按揭或其他融資' },
    { value: 'INTERNATIONAL_PAYMENTS', en: 'International payments', zh_CN: '国际汇款', zh_HK: '國際匯款' },
]